import { IBasicParagraph, IBlockContent } from '../interfaces';

export const defaultBasicParagraph: IBasicParagraph = {
  fieldTitle: '',
  fieldId: '',
  fieldDescription: '',
};

export const getContentBlockById = <T extends IBasicParagraph>(id: string, content: IBlockContent[]) =>
  (content.find((contentBlock) => contentBlock.fieldId === id) || defaultBasicParagraph) as T;
